import { LabelSection } from '@components/account/LabelSection';
import useSessionStore from '@services/stores/SessionStore';
import { makeStyles } from '@material-ui/styles';
import theme from '@components/theme';
import { useTranslation } from '@tools/i18n';
import { dateFormat } from '@services/Utils';
import { OrderType } from '@services/types/MyNewportOrderTypes';

const useStyles = makeStyles({
    orderHeader: {
        display: 'grid',
        gap: 20,
        paddingBottom: 20,
        marginBottom: 20,
        gridTemplateColumns: '1fr 1fr',

        // @ts-ignore
        [theme.breakpoints?.up('sm')]: {
            gridTemplateColumns: '1fr 1fr 1fr',
        },
    },
}, { name: 'account' });

interface OrderHeaderProps {
    type: OrderType;
    reference: string;
    status: string;
    total: number;
    currency: string;
    store: string;
    date: string | Date;
}

export function OrderHeader({ reference, status, total, currency, store, date, type }: OrderHeaderProps) {
    const classes = useStyles();
    const sessionMethods = useSessionStore((state) => state.methods);
    const { t } = useTranslation(['account']);

    let storeName  = store?.split('www.')?.[1]?.replaceAll('/', '');

    if (type === 'physical') {
        storeName = store;
    }

    let referenceLabel = t('account:label-order-number');
    if (type === 'physical') {
        referenceLabel = t('account:label-receipt-number');
    }

    function renderStoreLabel() {
        if (type === 'physical') {
            return null;
        }

        return <LabelSection label={t('account:label-store')} value={storeName}></LabelSection>
    }

    return <>
        <section className={classes.orderHeader}>
            <LabelSection label={referenceLabel} value={reference}></LabelSection>
            {renderStoreLabel()}
            <LabelSection label={t('account:label-date')} value={dateFormat(new Date(date))}></LabelSection>
            <LabelSection label={t('account:label-totals')} value={sessionMethods.formatPrice(total, currency).toString()}></LabelSection>
            <LabelSection label={t('account:label-status')} value={status}></LabelSection>
        </section>
    </>;
}
